import { accessTokenRequest } from '../../config/msalConfig'
import { msalInstance } from '../../msalClient'

export default async (headers: any) => {
  return acquireAccessToken().then(jwt => {
    let authorization = headers.get('Authorization')
    authorization = authorization ? authorization.replace('<JWT>', jwt) : jwt
    return headers.set('Authorization', authorization)
  })
}

const acquireAccessToken = async () => {
  const activeAccount = msalInstance.getActiveAccount()

  if (!activeAccount) {
    throw Error(
      'No active account! Verify a user has been signed in and setActiveAccount has been called.'
    )
  }

  const request = {
    ...accessTokenRequest(),
    account: activeAccount,
  }

  const authResult = await msalInstance.acquireTokenSilent(request)

  return authResult.accessToken
}
